import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "learned-something-new-brwant-to-become-an-expert"
    }}>{`Learned something new? `}<br />{`Want to become an expert?`}</h2>
    <p>{`Here's how it works 👇`}</p>
    <p>{`Leave your email and I'll send you thoughtfully written emails every week about `}<strong parentName="p">{`React`}</strong>{`, `}<strong parentName="p">{`JavaScript`}</strong>{`, and `}<strong parentName="p">{`your career`}</strong>{`. Lessons learned over 20 years in the industry working with companies ranging from tiny startups to Fortune5 behemoths.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      